module.exports = __webpack_public_path__ + "img/9_college.27b5fd52.png";